<div class="container-md">
    <div class="order-confirmation">
        <div class="order-confirmation__hero">
            <span class="order-confirmation__icon">
                <i class="fas fa-check"></i>
            </span>
            <span class="order-confirmation__eyebrow">{{ 'Vielen Dank!' | translate }}</span>
            <h2 class="order-confirmation__title">
                {{ 'Ihre Bestellung war erfolgreich!' | translate }}
            </h2>
            @if (allRequireApproval()) {
                <p class="order-confirmation__subtitle">
                    {{ 'Ihre Bestellung befindet sich im Freigabeprozess.' | translate }}
                </p>
            } @else if (noneRequireApproval()) {
                <p class="order-confirmation__subtitle">
                    {{ 'Ihre Bestellung wurde erfolgreich aufgegeben.' | translate }}
                </p>
            } @else {
                <p class="order-confirmation__subtitle">
                    {{ 'Ein Teil Ihrer Bestellungen befindet sich im Freigabeprozess.' | translate }}
                </p>
            }
        </div>

        <div class="order-confirmation__orders">
            <span class="order-confirmation__section">{{ 'Ihre Bestellungen' | translate }}</span>
            @for (item of order(); track item.id) {
                <div class="order-card">
                    <span class="order-card__avatar">
                        <i class="fas fa-store"></i>
                    </span>
                    <div class="order-card__body">
                        <span class="order-card__supplier">
                            {{ item.supplierCompanyName | supplierDisplayName: item.supplierNumber }}
                        </span>
                        <span class="order-card__meta">
                            <span class="order-card__meta-label">{{ 'Bestellnummer' | translate }}:</span>
                            <span class="order-card__number" copyToClipboard>{{ item.id }}</span>
                        </span>
                    </div>
                    <div class="order-card__actions">
                        @if (item.requiresApproval) {
                            <span class="order-card__status order-card__status--approval">
                                <i class="fas fa-hourglass-half"></i>{{ 'Im Freigabeprozess' | translate }}
                            </span>
                        } @else {
                            <span class="order-card__status order-card__status--placed">
                                <i class="fas fa-circle-check"></i>{{ 'Bestellung aufgegeben' | translate }}
                            </span>
                        }
                        <button
                            type="button"
                            class="btn btn-sm btn-primary order-card__link"
                            [routerLink]="'/client/order/' + item.id + '/detail'"
                        >
                            {{ 'Zur Bestellung' | translate }}<i class="fas fa-arrow-right ps-1"></i>
                        </button>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
